
















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import ScrollableTableCellFilter from "./ScrollableTableCellFilter.vue";
import { Cell } from "../../../../domain/system/table";

@Component({
  components: {
    ScrollableTableCellFilter,
  },
})
export default class ScrollableTableCell extends Mixins() {
  @Prop()
  cell: Cell;

  @Prop({ default: false })
  isTitle: boolean;

  @Prop({ default: false })
  isFilter: boolean;

  @Prop({ default: true })
  isVisible: boolean;

  @Prop()
  width: number;

  @Prop()
  columnCells: string[];

  @Prop()
  initialFilterText: string;

  mounted() {
    const td = this.$refs.container as HTMLElement;
    if (!this.width || this.width === -1) {
      // カラムの横幅が指定されていない場合の対応
      // 先頭の一行だけ投げたい
      this.$emit("cellWidthChanged", Math.max(td.clientWidth, 200)); // td.clientWidthはChromeとEdgeは200、IEは22
    }
  }

  onCellClicked(): void {
    if (this.isTitle || this.isFilter) { return; }
    this.$emit("cellClicked", this.cell, false);
  }

  onCellClickedWithCtrl(): void {
    if (this.isTitle || this.isFilter) { return; }
    this.$emit("cellClicked", this.cell, true);
  }

  onCellDoubleClicked(): void {
    if (this.isTitle || this.isFilter) { return; }
    this.$emit("cellDoubleClicked", this.cell);
  }

  @Emit("filterTextChanged")
  onFilterTextChanged(text: string): void {}

  @Emit("filterItemsChanged")
  onFilterItemsChanged(texts: string[]): void {}

  @Emit("enterKeyDown")
  onEnterKeyDown(): void {}

  get cellStylePropertoes(): any {
    return {
      width: (this.width > 0) ? this.width + "px" : null,
      overflow: (this.width > 0) ? "hidden" : "none",
      pointerEvents: !this.isFilter ? "none" : null,
    };
  }

  get tdStylePropertoes(): any {
    return {
      backgroundColor: this.getBackgroundColorText(),
    };
  }

  getBackgroundColorText(): string {
    if (this.isTitle) { return "skyblue"; }
    if (this.cell.isSelected) { return "yellow"; }
    return null;
  }

  get displayText(): string {
    return !!this.cell.displayText
      ? this.cell.displayText
      : this.cell.text;
  }
}
